import { ErrorMessage, Field, Form, FormikProvider, useFormik } from 'formik'
import React, { useEffect, useState } from 'react'
import CommonFormHeading from '../../CommonUtils/CommonFormHeading'
import * as bie from "react-bootstrap";
import { CommonAxiosGet, CommonAxiosPost } from '../../CommonUtils/CommonAxios';
import { config } from '../../CommonUtils/CommonURLS';
import Swal from 'sweetalert2';
import { failureAlert, successAlert2 } from '../../CommonUtils/SweetAlerts';
import { AC_YEAR_OLD, ERROR_MSG } from '../../CommonUtils/contextVariables';
import * as Yup from 'yup';


export default function AffiliationQuestions() {
    const AfflAuestion1validation = Yup.object({
        discreAvailableLocationOfCollege: Yup.string().required(ERROR_MSG).nullable(),
        discrepancyDetails: Yup.string().required(ERROR_MSG).nullable(),
        colgAccomadation: Yup.string().required(ERROR_MSG).nullable(),
        colgSubmittedEop: Yup.string().required(ERROR_MSG).nullable(),

        colgDeficiencyDiscremency: Yup.string().required(ERROR_MSG).nullable(),
        colgObtainedCourseRelatedProcedCouncil: Yup.string().required(ERROR_MSG).nullable(),
        councilDeficiencyDiscremency: Yup.string().required(ERROR_MSG).nullable(),
        colgShiftPremises: Yup.string().required(ERROR_MSG).nullable(),
        colgShiftPermissionTaken: Yup.string().required(ERROR_MSG).nullable(),
        colgAddressProposedShift: Yup.string().required(ERROR_MSG).nullable(),
        eoaSubmitted: Yup.string().required(ERROR_MSG).nullable(),

    })
    const AfflQuestion1Formik = useFormik({
        initialValues: {

            discreAvailableLocationOfCollege: "",
            discrepancyDetails: "",
            eoaSubmitted: "",
            colgEstDate: '',
            colgAccomadation: "",
            colgSubmittedEop: "",
            colgDeficiencyDiscremency: "",
            colgObtainedCourseRelatedProcedCouncil: "",
            councilDeficiencyDiscremency: "",
            colgShiftPremises: "",
            colgShiftPermissionTaken: "",
            colgAddressProposedShift: "",

        },
        validationSchema: AfflAuestion1validation,
        onSubmit: (values) => {

            Swal.fire({
                text: 'Are you sure you want to submit?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, submit it!',
                cancelButtonText: 'No, cancel!',
                backdrop: false,
            }).then((result) => {
                if (result.isConfirmed) {
                    const url = `${config.url.API_URL}saveAffiliationQuestions1details`;
                    CommonAxiosPost(url, values).then((res) => {
                        if (res?.data?.scode === '01') {
                            successAlert2(res?.data?.sdesc);
                            GetQuestiona1Data();
                        } else {
                            failureAlert(res?.data?.sdesc);
                        }
                    });
                } else {
                    console.log('Submission canceled');
                }
            });

        },
    })
    const [questions1, setquestiona1] = useState([]);
    function GetQuestiona1Data() {
        let url = config.url.API_URL + "getAffiliationQuestions1Details";
        CommonAxiosGet(url).then((res) => {
            if (res?.data?.scode === '01') {
                setquestiona1(res?.data?.getAffiliationQuestions1Details);
                AfflQuestion1Formik?.setFieldValue(`colgSubmittedEop`, res?.data?.getAffiliationQuestions1Details[0]?.colg_submitted_eop ?? '');

                AfflQuestion1Formik?.setFieldValue(`discrepancyDetails`, res?.data?.getAffiliationQuestions1Details[0]?.discrepancy_details);
                AfflQuestion1Formik?.setFieldValue(`eoaSubmitted`, res?.data?.getAffiliationQuestions1Details[0]?.eoa_submitted);
                AfflQuestion1Formik?.setFieldValue(`colgAccomadation`, res?.data?.getAffiliationQuestions1Details[0]?.colg_accomadation);
                AfflQuestion1Formik?.setFieldValue(`colgDeficiencyDiscremency`, res?.data?.getAffiliationQuestions1Details[0]?.colg_deficiency_discremency);
                AfflQuestion1Formik?.setFieldValue(`colgObtainedCourseRelatedProcedCouncil`, res?.data?.getAffiliationQuestions1Details[0]?.colg_obtained_course_related_proced_council);
                AfflQuestion1Formik?.setFieldValue(`councilDeficiencyDiscremency`, res?.data?.getAffiliationQuestions1Details[0]?.council_deficiency_discremency);
                AfflQuestion1Formik?.setFieldValue(`colgShiftPremises`, res?.data?.getAffiliationQuestions1Details[0]?.colg_shift_premises);
                AfflQuestion1Formik?.setFieldValue(`colgShiftPermissionTaken`, res?.data?.getAffiliationQuestions1Details[0]?.colg_shift_permission_taken);
                AfflQuestion1Formik?.setFieldValue(`colgAddressProposedShift`, res?.data?.getAffiliationQuestions1Details[0]?.colg_address_proposed_shift);
                AfflQuestion1Formik?.setFieldValue(`discreAvailableLocationOfCollege`, res?.data?.getAffiliationQuestions1Details[0]?.discre_available_location_of_college);
                AfflQuestion1Formik?.setFieldValue(`colgEstDate`, res?.data?.getAffiliationQuestions1Details[0]?.inst_estd);
            } else {
                setquestiona1([])

            }
        })
    }
    useEffect(() => {
        GetQuestiona1Data();
    }, [])

    return (
        <>
            <CommonFormHeading heading="Society Details Section - I" />

            <bie.Container fluid className="px-1" >
                <bie.Container className="outer-page-content-container shadow-none px-3 m-0 mw-100 pb-5" >
                    <FormikProvider value={AfflQuestion1Formik}>

                        <Form onChange={AfflQuestion1Formik.handleChange} onSubmit={AfflQuestion1Formik.handleSubmit} className='affl-form'>

                            <bie.Row className='px-2 my-3'>

                                <bie.Col xs={12} sm={12} md={12} lg={6} xl={6} xxl={3} className='mb-2'>
                                    <label className='mb-1'><b className='field-mandatory'>Name of the Society as per the Society Registration Certificate :	</b></label>
                                    <Field type="text" name="societycertificate" className="form-control mb-2" disabled value={questions1[0]?.society_name} />
                                </bie.Col>
                                <bie.Col xs={12} sm={12} md={12} lg={6} xl={6} xxl={3} className='mb-2'>
                                    <label className='mb-1' ><b className='field-mandatory'>Current Address of the college</b></label>
                                    <Field type="text" name="collegeaddress" className="form-control mb-2 mt-3 mt-xl-0 mt-xxl-3 mt-lg-2" disabled value={questions1[0]?.inst_address} />
                                </bie.Col>
                            </bie.Row>

                            <bie.Alert variant='danger' className='affl-alert'>
                                <h6 className='mb-0'>
                                    Please verify the address of the college in the Affiliation Order {AC_YEAR_OLD}, Address Proof, Approved Building Plans, Land documents, Sanitary Certificate,
                                    Fire NOC, Structural Soundness certificate and confirm if any discrepancy is found
                                </h6>
                            </bie.Alert>

                            <bie.Row className='px-2 my-3'>
                                <bie.Col xs={12} sm={12} md={12} lg={6} xl={6} xxl={3} className='mb-2'>
                                    <label ><b className='field-mandatory'>Is there any discrepancy available in the Address or location of the college:	</b></label>

                                    <Field
                                        as="select" className="form-control mt-0" name={'discreAvailableLocationOfCollege'}>
                                        <option value=''>--Select--</option>
                                        <option value="1" >Yes</option>
                                        <option value="2">No</option>
                                    </Field>
                                    <ErrorMessage name="discreAvailableLocationOfCollege" component="div" className="text-error" />

                                </bie.Col>
                                <bie.Col xs={12} sm={12} md={12} lg={6} xl={6} xxl={3} className='mb-2'>
                                    <label className='mb-1'><b className='field-mandatory'>Please enter the details of the Discrepancy ( If available else enter Not Applicable) :</b></label>
                                    <Field as='textarea' name="discrepancyDetails" className='form-control' maxLength="350" />
                                    <ErrorMessage name="discrepancyDetails" component="div" className="text-error" />

                                </bie.Col>
                            </bie.Row>
                            <div className="inner-herbpage-service-title-sub">
                                <h1 className="mb-0">Application Category Report details:
                                </h1></div>
                            <bie.Alert variant='danger' className='affl-alert mt-2'>
                                <h6 class="mb-0">Please refer to the Application Category Report and provide information in the below fields</h6>
                            </bie.Alert>
                            <bie.Row className='px-2 my-3'>
                                <bie.Col xs={12} sm={12} md={12} lg={6} xl={4} xxl={3} className='mb-2'>
                                    <label className='mb-1'><b className='field-mandatory'>Has the College submitted EOA Issued by AICTE for {AC_YEAR_OLD}:	</b></label>
                                    <Field
                                        as="select" className="form-control mb-2" name={'eoaSubmitted'}>
                                        <option value=''>--Select--</option>
                                        <option value="1" >Yes</option>
                                        <option value="2">No</option>
                                        <option value="3">Not Applicable</option>

                                    </Field>
                                    <ErrorMessage name="eoaSubmitted" component="div" className="text-error" />

                                </bie.Col>
                                <bie.Col xs={12} sm={12} md={12} lg={6} xl={4} xxl={3} className='mb-2'>
                                    <label className='mb-1' ><b className='field-mandatory'>Year of Establishment of College </b></label>
                                    <Field text="hidden" name="colgEstDate" className='form-control mb-2 mt-3 mt-lg-2 mt-xxl-3' />
                                </bie.Col>
                                <bie.Col xs={12} sm={12} md={12} lg={6} xl={4} xxl={3} className='mb-2'>
                                    <label className='mb-1'><b className='field-mandatory'>Is College Running in which Accommodation</b></label>
                                    <Field
                                        as="select" className="form-control mb-2 mt-3 mt-xl-0 mt-xxl-3 mt-lg-2" name={'colgAccomadation'}>
                                        <option value=''>--Select--</option>
                                        <option value="own" >Own</option>
                                        <option value="leased">Lease</option>
                                    </Field>
                                    <ErrorMessage name="colgAccomadation" component="div" className="text-error" />

                                </bie.Col>


                                {/* {createSelectField("colgAccomadation", [
                                    { value: 'own', label: 'Own' },
                                    { value: 'leased', label: 'Lease' }
                                ])} */}

                                <bie.Col xs={12} sm={12} md={12} lg={6} xl={4} xxl={3} className='mb-2'>
                                    <label className='mb-1'><b className='field-mandatory'>If leased , Has the college submitted EOP of APSCHE for {AC_YEAR_OLD}  </b></label>
                                    <Field
                                        as="select" className="form-control mb-2" name={'colgSubmittedEop'}>
                                        <option value=''>--Select--</option>
                                        <option value="1" >Yes</option>
                                        <option value="2">No</option>
                                        <option value="3">Not Applicable</option>
                                    </Field>
                                    <ErrorMessage name="colgSubmittedEop" component="div" className="text-error" />

                                </bie.Col>



                                {/* {createSelectField("colgSubmittedEop", [
                                    { value: '1', label: 'Yes' },
                                    { value: '2', label: 'No' },
                                    { value: '3', label: 'Not applicable' }

                                ])} */}
                                <bie.Col xs={12} sm={12} md={12} lg={6} xl={4} xxl={3} className='mb-2'>
                                    <label className='mb-1' ><b className='field-mandatory'>Please mention deficiencies /discrepancies identified ( if any):</b></label>
                                    <Field as='textarea' name="colgDeficiencyDiscremency" className='form-control' maxLength="350" />
                                    <ErrorMessage name="colgDeficiencyDiscremency" component="div" className="text-error" />

                                </bie.Col>
                                <bie.Col xs={12} sm={12} md={12} lg={8} xl={8} xxl={6} className='mb-2'>
                                    <label className='mb-1'><b className='field-mandatory'>Has the college obtained and submitted all the necessary Course related permission proceedings of Competent Authority( Council) for the Academic year {AC_YEAR_OLD} : </b></label>
                                    <Field
                                        as="select" className="form-control mb-2" name={'colgObtainedCourseRelatedProcedCouncil'}>
                                        <option value=''>--Select--</option>
                                        <option value="1" >Yes</option>
                                        <option value="2">No</option>
                                    </Field>
                                    <ErrorMessage name="colgObtainedCourseRelatedProcedCouncil" component="div" className="text-error" />

                                </bie.Col>
                                {/* {createSelectField("colgObtainedCourseRelatedProcedCouncil", [
                                    { value: '1', label: 'Yes' },
                                    { value: '2', label: 'No' }
                                ])} */}
                                <bie.Col xs={12} sm={12} md={12} lg={6} xl={4} xxl={3} className='mb-2'>
                                    <label className='mb-1' ><b className='field-mandatory'>Please mention deficiencies /discrepancies identified ( if any):</b></label>
                                    <Field as='textarea' name="councilDeficiencyDiscremency" className='form-control' maxLength="350" />
                                    <ErrorMessage name="councilDeficiencyDiscremency" component="div" className="text-error" />
                                </bie.Col>
                                <bie.Col xs={12} sm={12} md={12} lg={6} xl={4} xxl={3} className='mb-2'>
                                    <label className='mb-1'><b className='field-mandatory'>Has the college applied for Shift of Premises for the Academic year {AC_YEAR_OLD}: </b></label>
                                    <Field
                                        as="select" className="form-control mb-2" name={'colgShiftPremises'}>
                                        <option value=''>--Select--</option>
                                        <option value="1" >Yes</option>
                                        <option value="2">No</option>
                                    </Field>
                                    <ErrorMessage name="colgShiftPremises" component="div" className="text-error" />

                                </bie.Col>

                                {/* {createSelectField("colgShiftPremises", [
                                    { value: '1', label: 'Yes' },
                                    { value: '2', label: 'No' }
                                ])} */}
                                <bie.Col xs={12} sm={12} md={12} lg={8} xl={6} xxl={6} className='mb-2'>
                                    <label className='mb-1'><b className='field-mandatory'>Has the college submitted Permission Proceedings of Competent Authority ( Council) for Such shift :</b></label>
                                    <Field
                                        as="select" className="form-control mb-2 mt-3 mt-xl-0 mt-xxl-3 mt-lg-0" name={'colgShiftPermissionTaken'}>
                                        <option value=''>--Select--</option>
                                        <option value="1" >Yes</option>
                                        <option value="2">No</option>
                                        <option value="3">Not Applicable</option>
                                    </Field>
                                    <ErrorMessage name="colgShiftPermissionTaken" component="div" className="text-error" />

                                </bie.Col>


                                {/* {createSelectField("colgShiftPermissionTaken", [
                                    { value: '1', label: 'Yes' }, { value: '2', label: 'No' }, { value: '3', label: 'Not applicable' }

                                ])} */}

                                <bie.Col xs={12} sm={12} md={12} lg={8} xl={6} xxl={6} className='mb-2'>
                                    <label className='mb-1'><b className='field-mandatory'>Please enter the address to where the college is proposed to be shifted ( if applicable else Please enter Not Applicable): </b></label>
                                    <Field as='textarea' name="colgAddressProposedShift" className='form-control mb-2' maxLength="350" />
                                    <ErrorMessage name="colgAddressProposedShift" component="div" className="text-error" />
                                </bie.Col>
                            </bie.Row>
                            <div className="pt-1 mb-5">
                                <button type='submit' className='btn btn-success btn-sm float-end rounded mb-2  '>Submit</button>
                            </div>
                        </Form>
                    </FormikProvider>
                </bie.Container>

            </bie.Container>

        </>
    )
}
